// extracted by mini-css-extract-plugin
export default {"wrap":"contact_info_edit_form___wrap___d2a45d18","header":"contact_info_edit_form___header___a695eb7b","wrapper":"contact_info_edit_form___wrapper___aa637a05"};